// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TasksView-module__scopeBar___jV255 {
  margin-bottom: 12px;
}

.TasksView-module__teamTabsBar___d3C6O {
  margin-bottom: 8px;
}

.TasksView-module__teamTabsGroup___K0S40 {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0;
  border: 1px solid #ececf0;
  border-radius: 8px;
  background: #f5f5f5;
  overflow: hidden;
}

.TasksView-module__teamTabButton___QD6Pe {
  min-height: 30px;
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #a1a1aa;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  transition: background 120ms ease, box-shadow 120ms ease, color 120ms ease;
}

.TasksView-module__teamTabButton___QD6Pe:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.TasksView-module__teamTabActive___hkUk8 {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.TasksView-module__teamTabIcon___q1qZg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
  width: 14px;
  height: 14px;
}

.TasksView-module__teamTabCount___EhwRQ {
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: currentColor;
}

.TasksView-module__teamTabActive___hkUk8 .TasksView-module__teamTabCount___EhwRQ {
  font-weight: 600;
}

.TasksView-module__filters___Pl6i9 {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 8px 14px;
  margin-bottom: 12px;
}

.TasksView-module__filterRow___OWOhf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex: 1 1 auto;
  min-width: 0;
  flex-wrap: wrap;
}

.TasksView-module__filterRow___OWOhf + .TasksView-module__filterRow___OWOhf {
  margin-top: 0;
}

.TasksView-module__filterActions___hmoBE {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.TasksView-module__filterGroup___tVkDu {
  display: flex;
  gap: 1px;
  background: #f4f4f5;
  border-radius: 5px;
  padding: 2px;
}

@media (max-width: 900px) {
  .TasksView-module__teamTabsGroup___K0S40 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.TasksView-module__filterButton___z3RW4 {
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  background: transparent;
  color: #71717a;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.TasksView-module__filterButton___z3RW4:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TasksView-module__filterActive___kCAD4 {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.TasksView-module__filterCount___soaQE {
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  color: #a1a1aa;
  margin-left: 2px;
}

.TasksView-module__filterDivider___aCbrO {
  width: 1px;
  height: 20px;
  background: #e4e4e7;
}

.TasksView-module__filterActionButton___Q5yY1 {
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  background: #ffffff;
  color: #52525b;
  padding: 5px 10px;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
}

.TasksView-module__filterActionButton___Q5yY1:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TasksView-module__filterActionButton___Q5yY1:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.TasksView-module__layout___E70xN {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: start;
  padding-bottom: 80px;
}

.TasksView-module__layoutWithDetail____5oOj {
  grid-template-columns: minmax(0, 1fr) 440px;
}

.TasksView-module__listCard___IBvtO {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.TasksView-module__tableHeader___lMIZT {
  display: grid;
  grid-template-columns: 14px 1fr 96px 90px 78px 62px;
  gap: 10px;
  padding: 7px 14px;
  border-bottom: 1px solid #e4e4e7;
  background: #fafafa;
}

.TasksView-module__headerCell___BodJK {
  font-size: 10px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.TasksView-module__sortButton___pecDM {
  background: none;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  text-align: left;
}

.TasksView-module__sortButton___pecDM:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TasksView-module__sortActive___YPcsc {
  color: #18181b;
}

.TasksView-module__sortIcon___i2mP0 {
  width: 10px;
  height: 10px;
  opacity: 0.6;
}

.TasksView-module__sortActive___YPcsc .TasksView-module__sortIcon___i2mP0 {
  opacity: 1;
}

.TasksView-module__headerDue___d2GgN {
  text-align: right;
  justify-content: flex-end;
}

.TasksView-module__summaryBar____xfBL {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid #e4e4e7;
  background: #fafafa;
}

.TasksView-module__summaryMeta___WbSGW {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.TasksView-module__summaryActions___EIsMY {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.TasksView-module__summarySortMenu___leOXr {
  position: relative;
}

.TasksView-module__summarySortTrigger___Ensnw {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 11px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0;
}

.TasksView-module__summarySortTrigger___Ensnw:hover {
  color: #111827;
}

.TasksView-module__summarySortTrigger___Ensnw:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
  border-radius: 4px;
}

.TasksView-module__summarySortChevron___tX8qG {
  color: currentColor;
  transition: transform 120ms ease;
}

.TasksView-module__summarySortChevronOpen___KO663 {
  transform: rotate(180deg);
}

.TasksView-module__summarySortDropdown___AiXHR {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  min-width: 158px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  padding: 6px;
}

.TasksView-module__summarySortOption___X0B1M {
  width: 100%;
  border: none;
  background: transparent;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  font-size: 12px;
}

.TasksView-module__summarySortOption___X0B1M:hover {
  background: #f3f4f6;
  color: #111827;
}

.TasksView-module__summarySortOption___X0B1M:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.TasksView-module__summarySortCheck___rk9R7 {
  opacity: 0;
  color: #111827;
  flex-shrink: 0;
}

.TasksView-module__summarySortCheckVisible___PAdJV {
  opacity: 1;
}

.TasksView-module__summaryText___DOEKP {
  font-size: 11px;
  font-weight: 600;
  color: #52525b;
}

.TasksView-module__prioritySummary___IjJ4X {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.TasksView-module__prioritySummaryItem___vz4LM {
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}

.TasksView-module__prioritySummaryDivider___UM7VA {
  font-size: 11px;
  line-height: 1.2;
  color: #a1a1aa;
}

.TasksView-module__prioritySummaryCritical___T_uwl {
  color: #b91c1c;
  font-weight: 600;
}

.TasksView-module__prioritySummaryHigh___ZHJyG {
  color: #c2410c;
}

.TasksView-module__prioritySummaryMedium___eERUN {
  color: #ca8a04;
}

.TasksView-module__prioritySummaryLow___jbe2Q {
  color: #71717a;
}

.TasksView-module__summarySort___TA4W1 {
  border: none;
  background: transparent;
  font-size: 11px;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-family: "IBM Plex Mono", monospace;
}

@media (max-width: 720px) {
  .TasksView-module__summaryBar____xfBL {
    flex-direction: column;
  }
  .TasksView-module__summaryActions___EIsMY {
    width: 100%;
    justify-content: flex-start;
  }
}
.TasksView-module__emptyState___Bf_76 {
  padding: 40px;
  text-align: center;
  color: #a1a1aa;
  font-size: 13px;
}

.TasksView-module__loaderWrap___jTgQF {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.TasksView-module__detailPanel___BUto3 {
  align-self: start;
  position: sticky;
  top: 16px;
  max-height: calc(100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 54px);
  overflow-y: auto;
  scrollbar-width: none;
  padding-bottom: 80px;
}

.TasksView-module__detailPanel___BUto3::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.TasksView-module__patientGroup___p_yAT {
  border-bottom: 1px solid #e4e4e7;
}

.TasksView-module__leadRowWrap___spCHY {
  display: flex;
  align-items: center;
  background: #ffffff;
}

.TasksView-module__leadRowWrap___spCHY > .TasksView-module__patientRow___Rxu1O {
  flex: 1;
  min-width: 0;
}

.TasksView-module__leadPatientActions___B4JB5 {
  flex-shrink: 0;
  margin-right: 14px;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.TasksView-module__leadPatientLink___atzpn {
  padding: 4px 10px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  color: #3f3f46;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
  cursor: pointer;
}

.TasksView-module__leadPatientLink___atzpn:hover,
.TasksView-module__leadPatientLink___atzpn:focus-visible {
  border-color: #18181b;
  color: #18181b;
}

.TasksView-module__patientRow___Rxu1O {
  width: 100%;
  border: none;
  background: #ffffff;
  display: grid;
  grid-template-columns: 16px 3px minmax(0, 1fr) auto 72px;
  gap: 12px;
  align-items: center;
  padding: 14px;
  text-align: left;
  cursor: pointer;
}

.TasksView-module__queueGroupRow___tUBeO {
  width: 100%;
  border: none;
  background: #ffffff;
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 14px;
  text-align: left;
  cursor: pointer;
}

.TasksView-module__queueGroupRow___tUBeO:hover {
  background: #fafafa;
}

.TasksView-module__queueGroupRow___tUBeO:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.TasksView-module__queueGroupMain___cmfhT {
  min-width: 0;
}

.TasksView-module__patientRow___Rxu1O:hover {
  background: #fafafa;
}

.TasksView-module__patientRow___Rxu1O:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.TasksView-module__patientChevron___myqwT {
  color: #6b7280;
  flex-shrink: 0;
  transition: transform 150ms ease;
}

.TasksView-module__patientChevronCollapsed___QSTzZ {
  transform: rotate(-90deg);
}

.TasksView-module__patientMarker___nppFu {
  width: 3px;
  height: 36px;
  border-radius: 999px;
  background: #18181b;
}

.TasksView-module__patientMain___twevs {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.TasksView-module__patientTopRow___H8pES {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.TasksView-module__patientName___eeScu {
  font-size: 14px;
  font-weight: 600;
  color: #18181b;
}

.TasksView-module__patientMetaMuted___aYjDY {
  font-size: 12px;
  color: #a1a1aa;
  white-space: nowrap;
}

.TasksView-module__patientMetaRow___icMxd {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.TasksView-module__patientMetaText___UIxRk {
  font-size: 12px;
  color: #71717a;
}

.TasksView-module__pathwayBadge___ECuUa {
  line-height: 16px;
}

.TasksView-module__patientPills___nA_kr {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.TasksView-module__patientSummaryBadge___jdZFE {
  line-height: 18px;
}

.TasksView-module__summaryPillGroup___H3ywY {
  display: inline-flex;
  align-items: stretch;
}

.TasksView-module__summaryPill___b7hkk {
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 11px;
  line-height: 1;
  color: #18181b;
  background: #ffffff;
  white-space: nowrap;
}

.TasksView-module__summaryPillDark___lJAjz {
  background: #18181b;
  border-color: #18181b;
  color: #ffffff;
}

.TasksView-module__summaryPillGrouped___f9sG2 {
  border-radius: 4px 0 0 4px;
}

.TasksView-module__summaryPillGroupedTrailing___f0UQF {
  border-left: none;
  border-radius: 0 4px 4px 0;
}

.TasksView-module__patientDue___c1k0f {
  font-size: 12px;
  font-weight: 500;
  color: #18181b;
  text-align: right;
  white-space: nowrap;
  font-family: "IBM Plex Mono", monospace;
}

.TasksView-module__patientExpanded___EbZeQ {
  padding: 0 14px 14px 45px;
  background: #fafafa;
}

.TasksView-module__bucketSection___MrR_B + .TasksView-module__bucketSection___MrR_B {
  margin-top: 12px;
}

.TasksView-module__bucketHeader___EWQgO {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 0 8px;
}

.TasksView-module__bucketIndex___l0Csv {
  min-width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #d4d4d8;
  color: #71717a;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.TasksView-module__bucketIndexDark___mjav5 {
  background: #18181b;
  border-color: #18181b;
  color: #ffffff;
}

.TasksView-module__bucketLabel___nPVXa {
  font-size: 11px;
  font-weight: 700;
  color: #18181b;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.TasksView-module__bucketCount___lHhi0 {
  font-size: 11px;
  color: #71717a;
}

.TasksView-module__bucketRows___2BTSP {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
}

.TasksView-module__childSectionLabel___ApcBJ {
  padding: 10px 14px 6px 22px;
  font-size: 11px;
  font-weight: 600;
  color: #a1a1aa;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #ffffff;
}

.TasksView-module__childGroupContainer___aX3A8 {
  border-top: 2px solid #d4d4d8;
  border-bottom: 2px solid #d4d4d8;
  box-shadow: inset 0 2px 4px -2px rgba(0, 0, 0, 0.06), inset 0 -2px 4px -2px rgba(0, 0, 0, 0.06);
}

.TasksView-module__loadMoreWrap___cK8iA {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 14px 22px;
}

.TasksView-module__loadMoreButton___aZ_XE {
  border: none;
  background: transparent;
  color: #52525b;
  padding: 4px 0;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  font-family: "IBM Plex Mono", monospace;
  cursor: pointer;
  transition: color 120ms ease, opacity 120ms ease;
}

.TasksView-module__loadMoreButton___aZ_XE:hover:not(:disabled) {
  color: #18181b;
}

.TasksView-module__loadMoreButton___aZ_XE:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
  border-radius: 4px;
}

.TasksView-module__loadMoreButton___aZ_XE:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/TasksView/TasksView.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,MAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,0EACE;AAAJ;;AAKA;EACE,0BAAA;EACA,oBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,uCAAA;EACA,eAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAFF;;AAKA;EACE;IACE,gDAAA;EAFF;AACF;AAKA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAHF;;AAMA;EACE,0BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AAHF;;AAMA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAHF;;AAMA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,YAAA;AAHF;;AAMA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;AAHF;;AAMA;EACE,2CAAA;AAHF;;AAMA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mDAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,iBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kFACE;EAEF,YAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,mBAAA;EACA,cAAA;AALF;;AAQA;EACE,0BAAA;EACA,oBAAA;AALF;;AAQA;EACE,UAAA;EACA,cAAA;EACA,cAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,uCAAA;AALF;;AAQA;EACE;IACE,sBAAA;EALF;EAQA;IACE,WAAA;IACA,2BAAA;EANF;AACF;AASA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAPF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAPF;;AAUA;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,qHAAA;EAIA,gBAAA;EACA,qBAAA;EACA,oBAAA;AAVF;;AAaA;EACE,QAAA;EACA,SAAA;AAVF;;AAaA;EACE,gCAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,OAAA;EACA,YAAA;AAVF;;AAaA;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;AAVF;;AAaA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAVF;;AAaA;;EAEE,qBAAA;EACA,cAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,wDAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,+CAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,0BAAA;EACA,oBAAA;AAVF;;AAaA;EACE,YAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,0BAAA;EACA,oBAAA;AAVF;;AAaA;EACE,cAAA;EACA,cAAA;EACA,gCAAA;AAVF;;AAaA;EACE,yBAAA;AAVF;;AAaA;EACE,UAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,YAAA;EACA,aAAA;EACA,QAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAVF;;AAaA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAVF;;AAaA;EACE,eAAA;EACA,cAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,oBAAA;AAVF;;AAaA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAVF;;AAaA;EACE,0BAAA;AAVF;;AAaA;EACE,iBAAA;EACA,0BAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,uCAAA;AAVF;;AAaA;EACE,yBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAVF;;AAaA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAVF;;AAaA;EACE,eAAA;EACA,cAAA;AAVF;;AAaA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,6BAAA;EACA,gCAAA;EACA,+FACE;AAXJ;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;EACA,gDACE;AAbJ;;AAiBA;EACE,cAAA;AAdF;;AAiBA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,YAAA;AAdF","sourcesContent":[".scopeBar {\n  margin-bottom: 12px;\n}\n\n.teamTabsBar {\n  margin-bottom: 8px;\n}\n\n.teamTabsGroup {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0;\n  border: 1px solid #ececf0;\n  border-radius: 8px;\n  background: #f5f5f5;\n  overflow: hidden;\n}\n\n.teamTabButton {\n  min-height: 30px;\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  color: #a1a1aa;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  cursor: pointer;\n  transition:\n    background 120ms ease,\n    box-shadow 120ms ease,\n    color 120ms ease;\n}\n\n.teamTabButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.teamTabActive {\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.teamTabIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: currentColor;\n  width: 14px;\n  height: 14px;\n}\n\n.teamTabCount {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: currentColor;\n}\n\n.teamTabActive .teamTabCount {\n  font-weight: 600;\n}\n\n.filters {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  padding: 8px 14px;\n  margin-bottom: 12px;\n}\n\n.filterRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  flex: 1 1 auto;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.filterRow + .filterRow {\n  margin-top: 0;\n}\n\n.filterActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.filterGroup {\n  display: flex;\n  gap: 1px;\n  background: #f4f4f5;\n  border-radius: 5px;\n  padding: 2px;\n}\n\n@media (max-width: 900px) {\n  .teamTabsGroup {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.filterButton {\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 3px;\n  border: none;\n  cursor: pointer;\n  background: transparent;\n  color: #71717a;\n  box-shadow: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.filterButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.filterActive {\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.filterCount {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 10px;\n  color: #a1a1aa;\n  margin-left: 2px;\n}\n\n.filterDivider {\n  width: 1px;\n  height: 20px;\n  background: #e4e4e7;\n}\n\n.filterActionButton {\n  border: 1px solid #d4d4d8;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #52525b;\n  padding: 5px 10px;\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.filterActionButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.filterActionButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  align-items: start;\n  padding-bottom: 80px;\n}\n\n.layoutWithDetail {\n  grid-template-columns: minmax(0, 1fr) 440px;\n}\n\n.listCard {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.tableHeader {\n  display: grid;\n  grid-template-columns: 14px 1fr 96px 90px 78px 62px;\n  gap: 10px;\n  padding: 7px 14px;\n  border-bottom: 1px solid #e4e4e7;\n  background: #fafafa;\n}\n\n.headerCell {\n  font-size: 10px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.sortButton {\n  background: none;\n  border: none;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.sortButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.sortActive {\n  color: #18181b;\n}\n\n.sortIcon {\n  width: 10px;\n  height: 10px;\n  opacity: 0.6;\n}\n\n.sortActive .sortIcon {\n  opacity: 1;\n}\n\n.headerDue {\n  text-align: right;\n  justify-content: flex-end;\n}\n\n.summaryBar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  border-bottom: 1px solid #e4e4e7;\n  background: #fafafa;\n}\n\n.summaryMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.summaryActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.summarySortMenu {\n  position: relative;\n}\n\n.summarySortTrigger {\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: 11px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.summarySortTrigger:hover {\n  color: #111827;\n}\n\n.summarySortTrigger:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.summarySortChevron {\n  color: currentColor;\n  transition: transform 120ms ease;\n}\n\n.summarySortChevronOpen {\n  transform: rotate(180deg);\n}\n\n.summarySortDropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 20;\n  min-width: 158px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow:\n    0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -4px rgba(0, 0, 0, 0.1);\n  padding: 6px;\n}\n\n.summarySortOption {\n  width: 100%;\n  border: none;\n  background: transparent;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: left;\n  font-size: 12px;\n}\n\n.summarySortOption:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.summarySortOption:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.summarySortCheck {\n  opacity: 0;\n  color: #111827;\n  flex-shrink: 0;\n}\n\n.summarySortCheckVisible {\n  opacity: 1;\n}\n\n.summaryText {\n  font-size: 11px;\n  font-weight: 600;\n  color: #52525b;\n}\n\n.prioritySummary {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.prioritySummaryItem {\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.prioritySummaryDivider {\n  font-size: 11px;\n  line-height: 1.2;\n  color: #a1a1aa;\n}\n\n.prioritySummaryCritical {\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.prioritySummaryHigh {\n  color: #c2410c;\n}\n\n.prioritySummaryMedium {\n  color: #ca8a04;\n}\n\n.prioritySummaryLow {\n  color: #71717a;\n}\n\n.summarySort {\n  border: none;\n  background: transparent;\n  font-size: 11px;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n@media (max-width: 720px) {\n  .summaryBar {\n    flex-direction: column;\n  }\n\n  .summaryActions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n.emptyState {\n  padding: 40px;\n  text-align: center;\n  color: #a1a1aa;\n  font-size: 13px;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.detailPanel {\n  align-self: start;\n  position: sticky;\n  top: 16px;\n  max-height: calc(\n    100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) -\n      54px\n  );\n  overflow-y: auto;\n  scrollbar-width: none;\n  padding-bottom: 80px;\n}\n\n.detailPanel::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.patientGroup {\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.leadRowWrap {\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n}\n\n.leadRowWrap > .patientRow {\n  flex: 1;\n  min-width: 0;\n}\n\n.leadPatientActions {\n  flex-shrink: 0;\n  margin-right: 14px;\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.leadPatientLink {\n  padding: 4px 10px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #3f3f46;\n  font-size: 12px;\n  line-height: 18px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.leadPatientLink:hover,\n.leadPatientLink:focus-visible {\n  border-color: #18181b;\n  color: #18181b;\n}\n\n.patientRow {\n  width: 100%;\n  border: none;\n  background: #ffffff;\n  display: grid;\n  grid-template-columns: 16px 3px minmax(0, 1fr) auto 72px;\n  gap: 12px;\n  align-items: center;\n  padding: 14px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.queueGroupRow {\n  width: 100%;\n  border: none;\n  background: #ffffff;\n  display: grid;\n  grid-template-columns: 16px minmax(0, 1fr) auto;\n  gap: 12px;\n  align-items: center;\n  padding: 14px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.queueGroupRow:hover {\n  background: #fafafa;\n}\n\n.queueGroupRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.queueGroupMain {\n  min-width: 0;\n}\n\n.patientRow:hover {\n  background: #fafafa;\n}\n\n.patientRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.patientChevron {\n  color: #6b7280;\n  flex-shrink: 0;\n  transition: transform 150ms ease;\n}\n\n.patientChevronCollapsed {\n  transform: rotate(-90deg);\n}\n\n.patientMarker {\n  width: 3px;\n  height: 36px;\n  border-radius: 999px;\n  background: #18181b;\n}\n\n.patientMain {\n  min-width: 0;\n  display: grid;\n  gap: 6px;\n}\n\n.patientTopRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.patientName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.patientMetaMuted {\n  font-size: 12px;\n  color: #a1a1aa;\n  white-space: nowrap;\n}\n\n.patientMetaRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.patientMetaText {\n  font-size: 12px;\n  color: #71717a;\n}\n\n.pathwayBadge {\n  line-height: 16px;\n}\n\n.patientPills {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.patientSummaryBadge {\n  line-height: 18px;\n}\n\n.summaryPillGroup {\n  display: inline-flex;\n  align-items: stretch;\n}\n\n.summaryPill {\n  border: 1px solid #d4d4d8;\n  border-radius: 4px;\n  padding: 3px 8px;\n  font-size: 11px;\n  line-height: 1;\n  color: #18181b;\n  background: #ffffff;\n  white-space: nowrap;\n}\n\n.summaryPillDark {\n  background: #18181b;\n  border-color: #18181b;\n  color: #ffffff;\n}\n\n.summaryPillGrouped {\n  border-radius: 4px 0 0 4px;\n}\n\n.summaryPillGroupedTrailing {\n  border-left: none;\n  border-radius: 0 4px 4px 0;\n}\n\n.patientDue {\n  font-size: 12px;\n  font-weight: 500;\n  color: #18181b;\n  text-align: right;\n  white-space: nowrap;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.patientExpanded {\n  padding: 0 14px 14px 45px;\n  background: #fafafa;\n}\n\n.bucketSection + .bucketSection {\n  margin-top: 12px;\n}\n\n.bucketHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 0 8px;\n}\n\n.bucketIndex {\n  min-width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  background: #ffffff;\n  border: 1px solid #d4d4d8;\n  color: #71717a;\n  font-size: 10px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bucketIndexDark {\n  background: #18181b;\n  border-color: #18181b;\n  color: #ffffff;\n}\n\n.bucketLabel {\n  font-size: 11px;\n  font-weight: 700;\n  color: #18181b;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.bucketCount {\n  font-size: 11px;\n  color: #71717a;\n}\n\n.bucketRows {\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.childSectionLabel {\n  padding: 10px 14px 6px 22px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #a1a1aa;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  background: #ffffff;\n}\n\n.childGroupContainer {\n  border-top: 2px solid #d4d4d8;\n  border-bottom: 2px solid #d4d4d8;\n  box-shadow:\n    inset 0 2px 4px -2px rgba(0, 0, 0, 0.06),\n    inset 0 -2px 4px -2px rgba(0, 0, 0, 0.06);\n}\n\n.loadMoreWrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 18px 14px 22px;\n}\n\n.loadMoreButton {\n  border: none;\n  background: transparent;\n  color: #52525b;\n  padding: 4px 0;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1;\n  font-family: 'IBM Plex Mono', monospace;\n  cursor: pointer;\n  transition:\n    color 120ms ease,\n    opacity 120ms ease;\n}\n\n.loadMoreButton:hover:not(:disabled) {\n  color: #18181b;\n}\n\n.loadMoreButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.loadMoreButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scopeBar": `TasksView-module__scopeBar___jV255`,
	"teamTabsBar": `TasksView-module__teamTabsBar___d3C6O`,
	"teamTabsGroup": `TasksView-module__teamTabsGroup___K0S40`,
	"teamTabButton": `TasksView-module__teamTabButton___QD6Pe`,
	"teamTabActive": `TasksView-module__teamTabActive___hkUk8`,
	"teamTabIcon": `TasksView-module__teamTabIcon___q1qZg`,
	"teamTabCount": `TasksView-module__teamTabCount___EhwRQ`,
	"filters": `TasksView-module__filters___Pl6i9`,
	"filterRow": `TasksView-module__filterRow___OWOhf`,
	"filterActions": `TasksView-module__filterActions___hmoBE`,
	"filterGroup": `TasksView-module__filterGroup___tVkDu`,
	"filterButton": `TasksView-module__filterButton___z3RW4`,
	"filterActive": `TasksView-module__filterActive___kCAD4`,
	"filterCount": `TasksView-module__filterCount___soaQE`,
	"filterDivider": `TasksView-module__filterDivider___aCbrO`,
	"filterActionButton": `TasksView-module__filterActionButton___Q5yY1`,
	"layout": `TasksView-module__layout___E70xN`,
	"layoutWithDetail": `TasksView-module__layoutWithDetail____5oOj`,
	"listCard": `TasksView-module__listCard___IBvtO`,
	"tableHeader": `TasksView-module__tableHeader___lMIZT`,
	"headerCell": `TasksView-module__headerCell___BodJK`,
	"sortButton": `TasksView-module__sortButton___pecDM`,
	"sortActive": `TasksView-module__sortActive___YPcsc`,
	"sortIcon": `TasksView-module__sortIcon___i2mP0`,
	"headerDue": `TasksView-module__headerDue___d2GgN`,
	"summaryBar": `TasksView-module__summaryBar____xfBL`,
	"summaryMeta": `TasksView-module__summaryMeta___WbSGW`,
	"summaryActions": `TasksView-module__summaryActions___EIsMY`,
	"summarySortMenu": `TasksView-module__summarySortMenu___leOXr`,
	"summarySortTrigger": `TasksView-module__summarySortTrigger___Ensnw`,
	"summarySortChevron": `TasksView-module__summarySortChevron___tX8qG`,
	"summarySortChevronOpen": `TasksView-module__summarySortChevronOpen___KO663`,
	"summarySortDropdown": `TasksView-module__summarySortDropdown___AiXHR`,
	"summarySortOption": `TasksView-module__summarySortOption___X0B1M`,
	"summarySortCheck": `TasksView-module__summarySortCheck___rk9R7`,
	"summarySortCheckVisible": `TasksView-module__summarySortCheckVisible___PAdJV`,
	"summaryText": `TasksView-module__summaryText___DOEKP`,
	"prioritySummary": `TasksView-module__prioritySummary___IjJ4X`,
	"prioritySummaryItem": `TasksView-module__prioritySummaryItem___vz4LM`,
	"prioritySummaryDivider": `TasksView-module__prioritySummaryDivider___UM7VA`,
	"prioritySummaryCritical": `TasksView-module__prioritySummaryCritical___T_uwl`,
	"prioritySummaryHigh": `TasksView-module__prioritySummaryHigh___ZHJyG`,
	"prioritySummaryMedium": `TasksView-module__prioritySummaryMedium___eERUN`,
	"prioritySummaryLow": `TasksView-module__prioritySummaryLow___jbe2Q`,
	"summarySort": `TasksView-module__summarySort___TA4W1`,
	"emptyState": `TasksView-module__emptyState___Bf_76`,
	"loaderWrap": `TasksView-module__loaderWrap___jTgQF`,
	"detailPanel": `TasksView-module__detailPanel___BUto3`,
	"patientGroup": `TasksView-module__patientGroup___p_yAT`,
	"leadRowWrap": `TasksView-module__leadRowWrap___spCHY`,
	"patientRow": `TasksView-module__patientRow___Rxu1O`,
	"leadPatientActions": `TasksView-module__leadPatientActions___B4JB5`,
	"leadPatientLink": `TasksView-module__leadPatientLink___atzpn`,
	"queueGroupRow": `TasksView-module__queueGroupRow___tUBeO`,
	"queueGroupMain": `TasksView-module__queueGroupMain___cmfhT`,
	"patientChevron": `TasksView-module__patientChevron___myqwT`,
	"patientChevronCollapsed": `TasksView-module__patientChevronCollapsed___QSTzZ`,
	"patientMarker": `TasksView-module__patientMarker___nppFu`,
	"patientMain": `TasksView-module__patientMain___twevs`,
	"patientTopRow": `TasksView-module__patientTopRow___H8pES`,
	"patientName": `TasksView-module__patientName___eeScu`,
	"patientMetaMuted": `TasksView-module__patientMetaMuted___aYjDY`,
	"patientMetaRow": `TasksView-module__patientMetaRow___icMxd`,
	"patientMetaText": `TasksView-module__patientMetaText___UIxRk`,
	"pathwayBadge": `TasksView-module__pathwayBadge___ECuUa`,
	"patientPills": `TasksView-module__patientPills___nA_kr`,
	"patientSummaryBadge": `TasksView-module__patientSummaryBadge___jdZFE`,
	"summaryPillGroup": `TasksView-module__summaryPillGroup___H3ywY`,
	"summaryPill": `TasksView-module__summaryPill___b7hkk`,
	"summaryPillDark": `TasksView-module__summaryPillDark___lJAjz`,
	"summaryPillGrouped": `TasksView-module__summaryPillGrouped___f9sG2`,
	"summaryPillGroupedTrailing": `TasksView-module__summaryPillGroupedTrailing___f0UQF`,
	"patientDue": `TasksView-module__patientDue___c1k0f`,
	"patientExpanded": `TasksView-module__patientExpanded___EbZeQ`,
	"bucketSection": `TasksView-module__bucketSection___MrR_B`,
	"bucketHeader": `TasksView-module__bucketHeader___EWQgO`,
	"bucketIndex": `TasksView-module__bucketIndex___l0Csv`,
	"bucketIndexDark": `TasksView-module__bucketIndexDark___mjav5`,
	"bucketLabel": `TasksView-module__bucketLabel___nPVXa`,
	"bucketCount": `TasksView-module__bucketCount___lHhi0`,
	"bucketRows": `TasksView-module__bucketRows___2BTSP`,
	"childSectionLabel": `TasksView-module__childSectionLabel___ApcBJ`,
	"childGroupContainer": `TasksView-module__childGroupContainer___aX3A8`,
	"loadMoreWrap": `TasksView-module__loadMoreWrap___cK8iA`,
	"loadMoreButton": `TasksView-module__loadMoreButton___aZ_XE`
};
module.exports = ___CSS_LOADER_EXPORT___;
